const details = [
    {
        title: "Ticker",
        about: "~ Ticker is a personal task management application with an elegant ui and tons of features to optimize your workflow.",
        link: "https://ticker.kevinpaul.xyz",
        github: "https://github.com/itaintkevin/ticker-client",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "TailwindCSS",
        stack: ["Next.js", "JavaScript", "Redux-Toolkit", "Node.js", "Express.js", "MongoDB"]
    },
    {
        title: "OneRoof",
        about: "~ OneRoof is a modern and elegant real estate website that allows users to easily search and filter properties by name.",
        link: "https://oneroof.kevinpaul.xyz",
        github: "https://github.com/itaintkevin/oneroof",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["Next.js", "TypeScript", "TailwindCSS", "SanityCMS", "Swiper.js"]
    },
    {
        title: "Enigma",
        about: "~ One-time secrets message generator to share your private and secret info safely over the internet.",
        link: "https://enigma.kevinpaul.xyz",
        github: "https://github.com/itaintkevin/enigma",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["React.js", "Vite", "TailwindCSS", "Firebase", "Crypto.js"]
    },
    {
        title: "Altruize",
        about: "~ Decentralized NGO Donations Platform for safe and secure transactions, built for ETHforAll hackathon.",
        link: "https://altruize.vercel.app",
        github: "https://github.com/itaintkevin/Altruize",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["Next.js", "TypeScript", "TailwindCSS", "Solidity", "RainbowKit", "Hardhat"]
    },
    {
        title: "Buildspace Bounties",
        about: "~ Designed a buildspace bounties page that shows active bounties and leaderboard.",
        link: "https://buildspace-bounty.vercel.app/",
        github: "https://github.com/itaintkevin/buildspace-bounty",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["React.js", "TailwindCSS", "SanityCMS", "Chart.js"]
    },
    {
        title: "MovieMania",
        about: "~ A Movies Search Application using API Endpoint.",
        link: "https://moviemania22.vercel.app",
        github: "https://github.com/itaintkevin/MovieLand",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["React.js", "CSS"]
    },
    {
        title: "Expense Tracker",
        about: "~ An Expense Tracker application.",
        link: "https://expense-tracker22.vercel.app/",
        github: "https://github.com/itaintkevin/expense-tracker",
        img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
        stack1: "React.js",
        stack2: "CSS",
        stack: ["React.js", "Context API", "TailwindCSS"]
    },
    // {
    //     title: "Google Classroom",
    //     about: "~ GCR Homepage Clone.",
    //     link: "https://gcr-homepage-clone.vercel.app",
    //     github: "https://github.com/itaintkevin/gcr-homepage-clone",
    //     img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
    //     stack1: "React.js",
    //     stack2: "CSS",
    //     stack: ["React.js", "TailwindCSS"]
    // },
    {
        title: "Resize",
        about: "~ Image Resizing Application.",
        link: "https://itaintkevin.github.io/Image-Resizer",
        github: "https://github.com/itaintkevin/Image-Resizer",
        img: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/2048px-Unofficial_JavaScript_logo_2.svg.png",
        stack1: "HTML",
        stack2: "CSS",
        stack3: "JS",
        stack: ["HTML", "CSS", "JavaScript"]
    },
    {
        title: "Click!",
        about: "~ Camera Filters Application.",
        link: "https://itaintkevin.github.io/Click",
        github: "https://github.com/itaintkevin/Click",
        img: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/2048px-Unofficial_JavaScript_logo_2.svg.png",
        stack1: "HTML",
        stack2: "CSS",
        stack3: "JS",
        stack: ["HTML", "CSS", "JavaScript"]
    },
    // {
    //     title: "kzforms",
    //     about: "~ Form Application, posts data to API Endpoint.",
    //     link: "https://kzforms22.vercel.app",
    //     github: "https://github.com/itaintkevin/kzforms",
    //     img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
    //     stack1: "React.js",
    //     stack2: "TailwindCSS",
    //     stack3: "Axios",
    //     stack4: "React-Router",
    //     stack: ["React.js","TailwindCSS","Axios","React-Router"]
    // },
    // {
    //     title: "Estate",
    //     about: "~ Crowd Funded Real Estate NFT Marketplace.",
    //     link: "https://estate-one.vercel.app",
    //     github: "https://github.com/itaintkevin/Estate",
    //     img: "https://cdn-images-1.medium.com/max/280/1*lKN9xV1YEin-2wfAiGySBA.png",
    //     stack1: "React.js",
    //     stack2: "TailwindCSS",
    //     stack: ["React.js","TailwindCSS"]
    // },
]


export default details;